import React from 'react';
import Popover from 'react-bootstrap/lib/Popover';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import util from '../../../lib/util';

class ServiceOrderInfo extends React.Component {
  render() {
    const so = this.props.serviceOrder || {};
    const lookup = window.osa && window.osa.lookup;
    const st = lookup && lookup.status;
    const tip = st[so.status] && st[so.status].tip;
    return (
      <div className="row" style={{ borderBottom: "1px solid #dddddd", paddingTop: "5px" }}  >
        <div className="col-sm-3">
          {lookup && lookup.serviceType[so.applicationType]}
        </div>
        <div className="col-sm-2">
          {util.toProjectStatus(so.status)}&nbsp;
            <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={(<Popover>{tip}</Popover>)}>
            <i className="fa fa-info-circle info-icon" />
          </OverlayTrigger>
        </div>
        <div className="col-sm-3">
          {util.toFullDateString(util.dateFromString(so.scheduleStartDate))} - {util.toFullDateString(util.dateFromString(so.scheduleEndDate))}
        </div>
        <div className="col-sm-4">
          {
            so.premiseAddresses.map((x, key) =>
              <div className="row" key={key} >
                <div className="col-sm-12">
                  {util.addressToString(x)}
                </div>
              </div>)
          }

        </div>
      </div>
    );
  }
}

export default ServiceOrderInfo;


